import React, { useMemo } from "react";
import Tabs from "../components/Tabs";
import CategoriesTab from "./CategoriesTab";
import Sectors from "../UiPrompts/Sectors";
import JobRoles from "../UiPrompts/JobRoles";
import { Button, Tooltip } from "@mui/material";
import Swal from "sweetalert2";
import { useQueryClient } from "@tanstack/react-query";
import { useApplyDefaultAgencySettings } from "queries/agency";
import { useAgencyInfo } from "context/agency";

const AgentFramework = () => {
  const [agency, updateAgency] = useAgencyInfo();
  const queryClient = useQueryClient();

  const tabsData = useMemo(
    () => [
      { label: "Categories", content: <CategoriesTab /> },
      { label: "Sectors", content: <Sectors /> },
      { label: "Job Roles", content: <JobRoles /> },
    ],
    [],
  );

  const { mutateAsync: applyDefaultSettings, isPending: loading } = useApplyDefaultAgencySettings();

  const handleDefaulSettingsButtonClick = async () => {
    const { response, error } = await applyDefaultSettings(agency._id);
    if (response) {
      updateAgency(response?.data || {});
      queryClient.invalidateQueries({ queryKey: ["agency"] });
      Swal.fire("Success", "Default settings applied successfully.", "success");
    } else {
      Swal.fire("Error", error?.message || "Failed to apply default settings.", "error");
    }
  };

  return (
    <div className="pt-0 p-5">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <h2>Agent Framework</h2>
        <Tooltip title="Applying defaults will reset all tabs to the standard partner setup and remove you custom entries" placement="top">
          <button disabled={loading} onClick={handleDefaulSettingsButtonClick} style={{ background: "black", color: "white", paddingBlock: "12px", paddingInline: "16px", borderRadius: "8px", border: "1px solid black", cursor: "pointer" }}>Apply Default Settings</button>
        </Tooltip>
      </div>
      <div style={{ margin: "0px 0px 20px 0px" }}>
        <Tabs tabsData={tabsData} />
      </div>
    </div>
  );
};

export default AgentFramework;
